module.exports = require("../../svg/RundeckLogo.vue");